import React from "react";
import { NavLink, useLocation, withRouter } from "react-router-dom";

import { useProfile } from "app/context";
import { getProfilePath } from "app/links";
import { isCurrentRoute, t, Trans } from "app/utils";

const ActivityOptions = withRouter(({ user, isProfile }) => {
  const location = useLocation();
  const { profile } = useProfile();
  const { organization: { eventsEnabled, postsEnabled, recognitionsEnabled } } = profile;

  const baseUrl = isProfile ? "/profile" : getProfilePath(user);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div role="tablist" aria-label={t("User activity options")} className="nav nav-tabs user-activity-tabs">
          {postsEnabled && (
            <NavLink
              role="tab"
              aria-selected={isCurrentRoute("/profile/activity/posts", location, true)}
              to={`${baseUrl}/activity/posts`}
              exact
              activeClassName="active"
            >
              <Trans>Posts</Trans>
            </NavLink>
          )}
          {eventsEnabled && (
            <NavLink
              role="tab"
              aria-selected={isCurrentRoute("/profile/activity/events", location)}
              to={`${baseUrl}/activity/events`}
              isActive={(match, location) => ((match || location.pathname.includes(`${baseUrl}/activity/events`)))}
              activeClassName="active"
            >
              <Trans>Events</Trans>
            </NavLink>
          )}
          {recognitionsEnabled && (
            <NavLink
              role="tab"
              aria-selected={isCurrentRoute("/profile/activity/recognitions", location)}
              to={`${baseUrl}/activity/recognitions`}
              isActive={(match, location) => ((match || location.pathname.includes(`${baseUrl}/activity/recognitions`)))}
              activeClassName="active"
            >
              <Trans>Recognitions</Trans>
            </NavLink>
          )}
        </div>
      </div>
    </div>
  );
});

export default ActivityOptions;
